<template>
	<el-row class="points-show">
		<el-col :span="23">
			阅卷批考
		</el-col>
		<el-divider></el-divider>
		<el-row :gutter="20">
			<el-col :span="5">
				<div class="search-view">
					<div>试卷名称：</div>
					<el-input size="mini" placeholder="试卷名称" clearable />
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>批卷状态：</div>
					<el-select v-model="status" size="mini" clearable placeholder="请选择">
						<el-option v-for="item in testpaperStatus" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<el-button type="primary" size="mini" @click="handleSizeChange()">查询</el-button>
			</el-col>
		</el-row>
		<el-col :span="24">
			<el-table :data="tableData" :height="tableHeight">
				<el-table-column prop="testpaperName" label="试卷名称" width="180"> </el-table-column>
				<el-table-column prop="testpaperPassfraction" label="及格分数" width="180"> </el-table-column>
				<el-table-column prop="totalPassfraction" label="总分数"> </el-table-column>
				<el-table-column prop="courseName" label="关联课程"> </el-table-column>
				<el-table-column prop="wxNickname" label="代理名称(微信昵称)"> </el-table-column>
				<el-table-column prop="userName" label="代理名称(用户名)"> </el-table-column>
				<el-table-column prop="trueName" label="代理名称(真实姓名)"> </el-table-column>
				<el-table-column prop="endTime" label="开始答题时间"> </el-table-column>
				<el-table-column prop="endTime" label="结束答题时间"> </el-table-column>
				<el-table-column prop="score" label="考试参考分数"> </el-table-column>
				<el-table-column prop="status" label="批卷状态">
					<template slot-scope="scope">
						<span v-if="tableData[scope.$index].status==0">已批卷</span>
						<span v-if="tableData[scope.$index].status==1">未批卷</span>
					</template>
				</el-table-column>
				<el-table-column prop="actualScore" label="实际分数"> </el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button v-if="tableData[scope.$index].status==1" size="mini" plain type="primary"
							@click="openChapterDrawer(tableData[scope.$index])">批卷</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total,prev, pager, next" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange">
			</el-pagination>
		</el-col>
		<!-- 批卷 -->
		<el-col :span="24">
			<el-drawer title="" :visible.sync="testpaperDrawer" direction="btt" :before-close="closeTestpaperDrawer"
				size="93%">
				<el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm"
					style="height:100%">
					<el-row :gutter="20">
						<el-col :span="16" :offset="4">
							<el-col :span="8">
								<el-form-item label="姓名" prop="testpaperName">
									<el-input size="mini" disabled v-model="form.userName"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="总分" prop="totalPassfraction">
									<el-input size="mini" disabled v-model="form.totalPassfraction"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="及格分数" prop="totalPassfraction">
									<el-input size="mini" disabled v-model="form.testpaperPassfraction"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="系统评分" prop="totalPassfraction">
									<el-input size="mini" disabled v-model="form.score"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="得分" prop="totalPassfraction">
									<el-input size="mini" v-model="form.actualScore"></el-input>
								</el-form-item>
							</el-col>
						</el-col>
						<el-col :span="16" :offset="4">
							<el-col :span="10">共{{questions.length}}题</el-col>
						</el-col>
					</el-row>
					<!-- 试题部分 -->
					<el-row class="ques-row">
						<el-row v-for="(item,i) in questions" :key="i">
							<el-col :span="16" :offset="4">
								<el-divider><i class="el-icon-mobile-phone"></i>第{{i+1}}题</el-divider>
							</el-col>
							<el-row>
								<el-col :span="16" :offset="4">
									<el-col :span="8">
										<el-form-item label="试题内容">
											<el-input disabled size="mini" v-model="item.content"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="正确答案">
											<el-input disabled size="mini" v-model="item.successAnswer"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="用户答案">
											<el-input disabled size="mini" v-model="item.answer"></el-input>
										</el-form-item>
									</el-col>
								</el-col>
								<el-col :span="16" :offset="4">
									<el-col :span="8" v-if="item.subjectType == 0"
										v-for="(option,index) in item.options" :key="index">
										<el-form-item :label="option.optionName">
											<el-input size="mini" disabled v-model="option.optionContent"></el-input>
										</el-form-item>
									</el-col>
								</el-col>
							</el-row>
						</el-row>
					</el-row>
					<el-row>
						<el-col :span="4" :offset="10">
							<el-button type="primary" size="mini" @click="upload()">提交</el-button>
						</el-col>
					</el-row>
				</el-form>
			</el-drawer>
		</el-col>
	</el-row>
</template>

<script>
	import httpClient from "../../../util/request.js";
	export default {
		data() {
			return {
				// 分页组件
				pageNum: 1,
				pageSize: 15,
				total: null,
				// table 自适应高度
				tableHeight: window.innerHeight - 300,
				tableData: [],
				testpaperStatus: [{
					label: '全部',
					value: ''
				}, {
					label: '未批卷',
					value: '1'
				}, {
					label: '已批卷',
					value: '0'
				}],
				status: '',
				// 试卷的数据组
				testpaperData: [],
				// 试卷编辑或增加打开
				testpaperDrawer: false,
				form: {

				},
				rules: {},
				//用来存对应的试题内容
				questions: []
			}
		},
		created() {
			this.query();
		},
		methods: {
			upload() {
				console.log(this.form.examId + "============" + this.form.actualScore)
				this.$http.get('/api/source/clrExam/updateExamScore?pk=' + this.form.examId + '&score=' + this.form
					.actualScore, {}).then(res => {
					if (res.data.status == 0) {
						this.$message.success("打分成功");
						this.closeTestpaperDrawer();
						this.query();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			query() {
				this.$http.post('/api/source/clrExam/listPage?pageNum=' + this.pageNum + '&pageSize=' + this.pageSize, {})
					.then(res => {
						if (res.data.status == 0) {
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						} else {
							this.$message.error(res.data.msg);
						}
					});
			},
			openChapterDrawer(row) {
				this.$http.get('/api/source/clrExam/selectOne?pk=' + row.examId, {}).then(res => {
					if (res.data.status == 0) {
						this.form = res.data.data;
						this.questions = res.data.data.examSubject
					} else {
						this.$message.error(res.data.msg);
					}
				});
				this.testpaperDrawer = true
			},
			closeTestpaperDrawer() {
				this.testpaperDrawer = false
				this.$refs['form'].resetFields();
				this.form.courseId = '';
				this.questions = [];
			},
			// 分页组件
			handleSizeChange(val) {
				this.pageNum = 1;
				this.query();
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.query();
			},
		}
	}
</script>

<style lang="less" scoped>
	/deep/.el-input {
		height: auto;
	}
</style>
